
  <div class="item-selected" *ngIf="connection?.custom_name" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="5px">
    <div class="c-pointer" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="5px" *ngIf="connection.image_path"
      [matMenuTriggerFor]="menu">
     
      <img class="connect-logo" [src]="connection.image_path">
      <mat-icon class="icon-pointer ic-svg-9">keyboard_arrow_down</mat-icon>
   
  </div>
    <div class="fs-14 fc-6">{{ connection.custom_name }}</div>
  </div>

  <div fxLayout="column" fxLayoutAlign="center start">
    <div fxLayout="row">
      <button fxLayout="row" fxLayoutAlign="start center" class="btn-add" *ngIf="!connection?.custom_name"
        [matMenuTriggerFor]="menu">
        <mat-icon>add_circle_outline</mat-icon>
        <span>{{ 'authorization.addConnection' | translate }}</span>
      </button>

      <mat-menu class="services-selector" #menu="matMenu">
        <button mat-menu-item *ngFor="let connect of connection.connections"
          [ngClass]="{ 'selected': connect.selected }"
          (click)="connect.selected ? removeConnection.emit() : addConnection.emit(connect)">
          <div class="service-option" fxLayout="row" fxLayoutAlign="space-between center">
            <div fxLayout="column" fxLayoutAlign="start start">
              <img class="connect-logo mt-2" [src]="connect.image_path">
              <div class="fs-14 fc-6 pt-2">{{ connect.custom_name }}</div>
            </div>
            <mat-icon class="ic-svg-green" *ngIf="!connect.selected">add_circle_outline</mat-icon>
            <mat-icon *ngIf="connect.selected">delete_outline</mat-icon>
          </div>
        </button>
      </mat-menu>
    </div>
  </div>
